/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import OrganizationProfile from 'entities/OrganizationProfile';

import type { OrganizationType } from 'queries/__generated__/globalGQLTypes';

class OrganizationProfiles extends Collection<OrganizationProfile> {
  initialize() {
    this.model = OrganizationProfile;
  }

  static search(
    // parity with Organizations.search
    queryType: OrganizationType,
    query: string,
    page: number = 1,
    perPage: number = 20
  ) {
    const options = {
      query,
      page: page || 1,
      per_page: perPage || 20,
    };

    return apiRequest('/organization_profiles', 'GET', options).then(response =>
      OrganizationProfiles.fromJSON(response)
    );
  }
}

export default OrganizationProfiles;
